"use strict";

var insertSequenceDataAtPositionOrRange = require("./insertSequenceDataAtPositionOrRange");

module.exports = insertSequenceDataAtPositionOrRange;